import Paie, { SynthesePaie as SynthesePaieBase, Cotisation as CotisationBase } from '@/generated/classes/Paie';
export default class PaieExtend  extends Paie {
  constructor() {
    super();
  }

  // eslint-disable-next-line
  public static getTitle (paie: Paie): string {
    return 'Title';
  }

  // eslint-disable-next-line
  public static getSubtitle (paie: Paie): string {
    return 'Subtitle';
  }

  // eslint-disable-next-line
  public static getInfo (paie: Paie): string {
    return 'Info';
  }

  public static getData (paie: Paie): string[] {
    const res: string[] = [];
    res.push(PaieExtend.getTitle(paie));
    res.push(PaieExtend.getSubtitle(paie));
    res.push(PaieExtend.getInfo(paie));
    return res;
  }

  // eslint-disable-next-line
  public static getPicto (paie: Paie): string {
    return 'Paie';
  }
}

export class SynthesePaie extends SynthesePaieBase {
    constructor() {
    super();
  }
}

export class Cotisation extends CotisationBase {
  constructor() {
  super();
}
}